import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InteractionListenerService {
  // A Subject that will emit a value when the first interaction occurs.
  private firstInteraction = new Subject<boolean>();
  public firstInteraction$ = this.firstInteraction.asObservable();

  private listenerAttached = false;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    // Only run this logic in the browser
    if (isPlatformBrowser(this.platformId)) {
      this.attachInteractionListeners();
    }
  }

  private attachInteractionListeners(): void {
    if (this.listenerAttached) {
      return;
    }

    const interactionEvents: (keyof WindowEventMap)[] = ['mousemove', 'scroll', 'keydown', 'touchstart'];

    const onFirstInteraction = () => {
      // Emit true to notify all subscribers
      this.firstInteraction.next(true);
      this.firstInteraction.complete(); // We only need this to fire once

      // Clean up the listeners to save memory
      interactionEvents.forEach(event =>
        window.removeEventListener(event, onFirstInteraction)
      );
      this.listenerAttached = false;
    };

    interactionEvents.forEach(event =>
      window.addEventListener(event, onFirstInteraction, { passive: true, once: true })
    );

    this.listenerAttached = true;
  }
}
